import ReactMarkdown from 'react-markdown';
import '../stylesheets/FiltrosManuales.css';
import remarkGfm from 'remark-gfm';
import React, { useState, useCallback, useEffect } from 'react';
import { FiCopy, FiInfo } from "react-icons/fi";
import Select from 'react-select';
import Lottie from "lottie-react";
import hourglassAnimation from "../assets/C0DvzRjMMN.json";
import { createPortal } from 'react-dom';

const Analisis1 = () => {

  const STATES = ["FL", "CA", "TX", "IL", "PA", "GA", "AZ", "NC", "NJ", "UT", "WA", "WI"];
  const ALL_OPTION = "Todos";
  const allOptions = [ALL_OPTION, ...STATES];
  // ⬅️ Estado ELEVADO al padre
  const [statesSelected, setStatesSelected] = React.useState([]);
  const SAFETY_OPTIONS = [
  { value: "S", label: "Satisfactory" },
  { value: "U", label: "Unsatisfactory" },
  { value: "C", label: "Conditional" },
  { value: "NOT RATED", label: "Not Rated" },
];
  const [powerUnits, setPowerUnits] = useState([]);
  const OPTIONS_POWER_UNITS = [
    { value: "1", label: "1 unidad" },
    { value: "2", label: "2 unidades" },
    { value: "3", label: "3 unidades" },
    { value: "4", label: "4 unidades" },
    { value: "5", label: "5 unidades" },
    { value: "6", label: "6 unidades" },
    { value: "7", label: "7 unidades" },
    { value: "8", label: "8 unidades" },
    { value: "9", label: "9 unidades" },
    { value: "10", label: "10 unidades" },
    { value: "+10", label: "Más de 10 unidades" },
  ];
  const [safetySelected, setSafetySelected] = useState([]);
  const [crashes2yr, setCrashes2yr] = useState([]);
  const [injuries2yr, setInjuries2yr] = useState([]);
  const [fatalities2yr, setFatalities2yr] = useState([]);
  const [basicAlerts, setBasicAlerts] = useState([]);
  const OPTIONS_EVENTS = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "+10", label: "Más de 10" },
    ];



  // Multiselect controlado por el padre
  const MultiSelectEstados = ({ statesSelected, setStatesSelected }) => {
    const [open, setOpen] = React.useState(false);

    const toggleOption = (state) => {
      setStatesSelected((prev) =>
        prev.includes(state)
          ? prev.filter((s) => s !== state)
          : [...prev, state]
      );
    };

    return (
      <div className="form-group">
        <label className="tooltip-container">
          <strong>Estados (Selección múltiple)*</strong>
          <span className="tooltip-text">Marca varios estados si aplica.</span>
        </label>
        <div
          className={`custom-multiselect ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <div className="selected-values">
            {statesSelected.length > 0 ? statesSelected.join(", ") : "Selecciona estados"}
          </div>
          <div className="arrow"></div>
        </div>

        {open && (
          // Evita que el click dentro cierre el dropdown
          <div className="options" onClick={(e) => e.stopPropagation()}>
          {allOptions.map((s) => (
            <label key={s} className="option-item">
              <input
                type="checkbox"
                checked={
                  s === ALL_OPTION
                    ? statesSelected.length === STATES.length
                    : statesSelected.includes(s)
                }
                onChange={() => {
                  if (s === ALL_OPTION) {
                    const isAllSelected = statesSelected.length === STATES.length;
                    setStatesSelected(isAllSelected ? [] : [...STATES]);
                  } else {
                    toggleOption(s);
                  }
                }}
              />
              {s}
            </label>
          ))}

          </div>
        )}
      </div>
    );
  };
  const MultiSelectSafety = ({ safetySelected, setSafetySelected }) => {
    const [open, setOpen] = useState(false);

    const toggleOption = (opt) => {
      setSafetySelected((prev) =>
        prev.includes(opt) ? prev.filter((s) => s !== opt) : [...prev, opt]
      );
    };

    return (
      <div className="form-group">
        <label className="tooltip-container">
          <strong>Safety Rating </strong>
          <span className="tooltip-text">Marca uno o varios niveles de calificación.</span>
        </label>
        <div
          className={`custom-multiselect ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <div className="selected-values">
            {safetySelected.length > 0 ? safetySelected.join(", ") : "Selecciona niveles"}
          </div>
          <div className="arrow"></div>
        </div>

        {open && (
          <div className="options" onClick={(e) => e.stopPropagation()}>
            {SAFETY_OPTIONS.map((opt) => (
              <label key={opt.value} className="option-item">
                <input
                  type="checkbox"
                  checked={safetySelected.includes(opt.value)}
                  onChange={() => toggleOption(opt.value)}
                />
                {opt.label}
              </label>
            ))}
          </div>
        )}
      </div>
    );
  };

  const MultiSelectYIB = ({ yibSelected, setYibSelected }) => {
  const [open, setOpen] = useState(false);


  const toggleOption = (opt) => {
  setYibSelected((prev) =>
  prev.includes(opt) ? prev.filter((s) => s !== opt) : [...prev, opt]
  );
  };


  return (
  <div className="form-group">
  <label className="tooltip-container">
  <strong>Years in Business</strong>
  <span className="tooltip-text">Selecciona los rangos de años en operación.</span>
  </label>
  <div
  className={`custom-multiselect ${open ? "open" : ""}`}
  onClick={() => setOpen(!open)}
  >
  <div className="selected-values">
  {yibSelected.length > 0 ? yibSelected.join(", ") : "Selecciona años"}
  </div>
  <div className="arrow"></div>
  </div>


  {open && (
  <div className="options" onClick={(e) => e.stopPropagation()}>
  {YIB_OPTIONS.map((s) => (
  <label key={s} className="option-item">
  <input
  type="checkbox"
  checked={yibSelected.includes(s)}
  onChange={() => toggleOption(s)}
  />
  {s}
  </label>
  ))}
  </div>
  )}
  </div>
  );
  };
  
  const [dot, setDot] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const YIB_OPTIONS = ["0", "1", "2", "3", "4", "5+"];
  const [yibSelected, setYibSelected] = useState([]);
  const formatCarrierResultadoToTSV = (resultado = []) => {
    const header = ['InsCarrier', 'Frecuencia', 'Porcentaje'].join('\t');
    const rows = resultado.map(r => [
      String(r.InsCarrier ?? '').trim(),
      String(r.Frecuencia ?? ''),
      `${Math.round(Number(r.Porcentaje ?? 0))}%`
    ].join('\t'));
    return [header, ...rows].join('\n');
  };

  const handleCopyAllExceptDotInfo = useCallback(() => {
    const root = document.querySelector('.analisis1-box');
    if (!root) return alert('No encontré el contenedor.');

    const clone = root.cloneNode(true);

    // quita DOT Info + formulario y botones
    clone
      .querySelectorAll('.dot-info, form, .copy-btn, .file-drop-zone, .selected-files')
      .forEach(n => n.remove());

    const style = `
      <style>
        body { font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif; }
        h1,h2,h3,h4 { margin: 0.4rem 0 0.6rem; }
        p, li { line-height: 1.4; }
        hr { border: 0; border-top: 1px solid #e5e7eb; margin: 12px 0; }
        table { border-collapse: collapse; width: 100%; margin: 8px 0; }
        th, td { border: 1px solid #ccc; padding: 8px; text-align: left; vertical-align: top; }
        tr:nth-child(even) { background: #f9f9f9; }
        th { background: #f0f4ff; color: #1d4ed8; }
        .table-title-bar h4 { background:#143D8C; color:#fff; padding:10px 14px; border-radius:10px; display:inline-block; }
      </style>
    `;

    const html = style + clone.innerHTML;
    const text = clone.innerText;

    if (!window.ClipboardItem) {
      navigator.clipboard.writeText(text)
        .then(() => alert('Copiado como texto (sin formato)'))
        .catch(err => alert('Error copiando: ' + err));
      return;
    }

    navigator.clipboard.write([
      new ClipboardItem({
        'text/html': new Blob([html],  { type: 'text/html'  }),
        'text/plain': new Blob([text], { type: 'text/plain' })
      })
    ])
    .then(() => alert('✅ Copiado'))
    .catch(err => alert('❌ Error al copiar: ' + err));
  }, []);

  const normalizeDotInfoToTSV = (text = '') => {
    const headers = [
      "Docket", "DotNo", "LegalName", "DbaName", "Address", "City", "State", "CountyName", "Zip",
      "Undeliverable", "Phone", "CellPhone", "Fax", "Email", "CompanyRep1", "CompanyRep2", "MailAddress",
      "MailCity", "MailState", "MailZip", "MailUndeliverable", "YearsInBusiness", "DOTRegistrationDate",
      "InsEffDate", "InsEffMonth", "InsEffDay", "InsEffYear", "InsCarrier", "InsType", "PolicyNo",
      "Cancellation_Date", "InsRequired", "InsOnFile", "TrucksOwned", "TractorsOwned", "TrailersOwned",
      "BusesOwned", "TrucksLeased", "TractorsLeased", "TrailersLeased", "BusesLeased", "TotalNumTrucks",
      "TotalNumBuses", "TotalNumPowUnits", "CargoCode", "CargoOther", "CarrierOperation", "MCS150Date",
      "MCS150Miles", "MCS150MilageYear", "SafetyRating", "SafetyRatingDate", "FormCode", "CrashPURatio",
      "CrashesPast2Yr", "InjuriesPast2Yr", "FatalitiesPast2Yr", "BasicAlerts", "Est_ISS Category",
      "Est ISS Score", "DriverOOS", "VehicleOOS", "TotalOOS", "UD PCT", "HS PCT", "DF_PCT", "CS PCT",
      "VM PCT", "HM PCT", "Crash PCT", "UD Alert", "HS Alert", "DF Alert", "CS Alert", "VM Alert",
      "HM Alert", "Crash_Alert", "DatePosted"
    ];

    const lines = text.trim().split('\n').filter(Boolean);
    const rows = lines.slice(1);

    const parsedRows = rows.map((line) => {
      const rawTokens = line.trim().split(/\s+/);
      const tokens = rawTokens.map(t => {
        if (/^None$/i.test(t)) return ' ';
        if (/^\d+\.\d+$/.test(t)) return t.replace(/\.0$/, '');
        return t;
      });

      const maxCols = headers.length;
      const padded = [];

      let i = 0;
      while (padded.length < maxCols && i < tokens.length) {
        if (padded.length === 2) {
          let name = tokens[i];
          while (i + 1 < tokens.length && /^[A-Z0-9&]+$/.test(tokens[i + 1]) && padded.length < 3) {
            name += ' ' + tokens[++i];
          }
          padded.push(name);
          i++;
        } else {
          padded.push(tokens[i++]);
        }
      }

      while (padded.length < maxCols) padded.push('');
      return padded.slice(0, maxCols);
    });

    return [headers.join('\t'), ...parsedRows.map(r => r.join('\t'))].join('\n');
  };

  const TableOrMarkdown = ({
    text = '',
    title,
    className,
    scroll = false,
    headerDelimiter = 'auto',
    rowDelimiter = 'auto',
    customTitleClass,
    scrollForTitles = [],
  }) => {
    const clean = String(text).trim();
    if (!clean) return null;

    const flattenText = (nodes) => {
      const arr = React.Children.toArray(nodes);
      return arr.map((n) => {
        if (typeof n === 'string' || typeof n === 'number') return String(n);
        if (React.isValidElement(n)) return flattenText(n.props?.children);
        return '';
      }).join('');
    };
    const normalize = (s) =>
      String(s || '')
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}\s:()\-]/gu, '')
        .replace(/\s+/g, ' ')
        .trim();
    const shouldWrap = (sectionText) => {
      if (!sectionText) return false;
      const norm = normalize(sectionText);
      return scrollForTitles.some(t => norm.includes(normalize(t)));
    };

    const looksLikeMdTable = /\|.+\|/.test(clean) && /(\n|\r)\s*\|?-{3,}/.test(clean);

    if (looksLikeMdTable && headerDelimiter === 'auto' && rowDelimiter === 'auto') {
      let currentSection = '';

      const md = (
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h3({ children, ...props }) {
              currentSection = flattenText(children);
              return <h3 {...props}>{children}</h3>;
            },
            p({ children, ...props }) {
              const first = React.Children.toArray(children)[0];
              if (React.isValidElement(first) && first.type === 'strong') {
                currentSection = flattenText(first.props?.children);
              }
              return <p {...props}>{children}</p>;
            },
            strong({ children, ...props }) {
              const boldText = flattenText(children);
              if (shouldWrap(boldText)) currentSection = boldText;
              return <strong {...props}>{children}</strong>;
            },
            table({ children, ...props }) {
              const tbl = <table className="data-table" {...props}>{children}</table>;
              return shouldWrap(currentSection)
                ? <div className="table-scroll">{tbl}</div>
                : tbl;
            },
          }}
        >
          {clean}
        </ReactMarkdown>
      );

      return (
        <div className={className}>
          {title && <h4 className={customTitleClass}>{title}</h4>}
          {md}
        </div>
      );
    }

    const pickSplitter = (mode, sampleRows) => {
      if (mode === 'whitespace') return /\s+/;
      if (mode === 'spaces2') return /\s{2,}/;
      if (mode === 'tsv') return /\t+/;
      return sampleRows.some(r => r.includes('\t')) ? /\t+/ : /\s{2,}/;
    };

    const rowsRaw = clean.split(/\r?\n/).map(r => r.trimEnd()).filter(Boolean);
    if (rowsRaw.length === 0) return null;

    const headSplit = pickSplitter(headerDelimiter, rowsRaw);
    let header = rowsRaw[0].split(headSplit).filter(Boolean).map(s => s.trim());
    header = header.map(h => /^inscarrier$/i.test(h) ? 'Carrier sugerido' : h);
    const expectedCols = header.length;

    const bodyLines = rowsRaw.slice(1);
    const combinedRows = [];
    let currentRow = '';

    for (let line of bodyLines) {
      if (!currentRow) {
        currentRow = line;
      } else {
        const cells = currentRow.split(pickSplitter(rowDelimiter, [currentRow]));
        if (cells.length < expectedCols) {
          currentRow += ' ' + line;
        } else {
          combinedRows.push(currentRow);
          currentRow = line;
        }
      }
    }
    if (currentRow) combinedRows.push(currentRow);

    const body = combinedRows
      .map(row => {
        const cells = row.split(pickSplitter(rowDelimiter, [row])).map(s => s.trim());
        if (cells.length < expectedCols) return cells.concat(Array(expectedCols - cells.length).fill(''));
        if (cells.length > expectedCols) {
          return [
            cells.slice(0, cells.length - (expectedCols - 1)).join(' '),
            ...cells.slice(cells.length - (expectedCols - 1))
          ];
        }
        return cells;
      })
      .map(cells => {
        const idx = header.findIndex(h => h.replace(/\s/g, '').toLowerCase() === 'porcentaje');
        if (idx !== -1 && !isNaN(parseFloat(cells[idx]))) {
          const val = parseFloat(cells[idx]);
          cells[idx] = `${Math.round(val)}%`;
        }
        return cells;
      });

    const tableEl = (
      <table className={`data-table ${scroll ? 'data-table--wide' : ''}`}>
        <thead>
          <tr>{header.map((h, i) => <th key={i}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {body.map((cells, i) => (
            <tr key={i}>
              {cells.map((c, j) => <td key={j}>{c}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    );

    return (
      <div className={className}>
        {title && <h4 className={customTitleClass}>{title}</h4>}
        {scroll ? <div className="table-scroll">{tableEl}</div> : tableEl}
      </div>
    );
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    processFiles(selectedFiles);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    processFiles(droppedFiles);
  };

  const processFiles = useCallback((files) => {
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    setFiles(pdfFiles);
  }, []);

  const handleSubmit = async (e) => {
  e.preventDefault();


  if (statesSelected.length === 0) {
  alert("Selecciona al menos un estado.");
  return;
  }


  const payload = {
  State: statesSelected,
  SafetyRating: safetySelected,
  YearsInBusiness: yibSelected,
  };


  if (powerUnits.length > 0) {
  payload["TotalNumPowUnits"] = powerUnits.map(val =>
  val === "+10" ? ">=10" : `<=${val}`
  );
  }


  if (crashes2yr.length > 0) {
  payload["CrashesPast2Yr"] = crashes2yr.map(val =>
  val === "+10" ? ">=10" : `<=${val}`
  );
  }


  if (injuries2yr.length > 0) {
  payload["InjuriesPast2Yr"] = injuries2yr.map(val =>
  val === "+10" ? ">=10" : `<=${val}`
  );
  }


  if (fatalities2yr.length > 0) {
  payload["FatalitiesPast2Yr"] = fatalities2yr.map(val =>
  val === "+10" ? ">=10" : `<=${val}`
  );
  }
  if (basicAlerts.length > 0) {
    payload["BasicAlerts"] = basicAlerts.map(val =>
      val === "+10" ? ">=10" : `<=${val}`
    );
  }

  setApiResponse(null);
  setIsLoading(true);


  try {
  const resp = await fetch("https://carrierprobapi.intruckscorp.com/Top_analizar_por_filtros", {
  method: "POST",
  headers: {
  "Content-Type": "application/json",
  "accept": "application/json"
  },
  body: JSON.stringify(payload),
  });


  if (!resp.ok) {
  const t = await resp.text();
  throw new Error(t || resp.statusText);
  }


  const data = await resp.json();
  setApiResponse(data);
  } catch (err) {
  console.error(err);
  alert("Error enviando filtros: " + err.message);
  } finally {
  setIsLoading(false);
  }
  };



  return (
    <div className="right-section">
      <div className="analisis1-box">
        <div className="title-row">
          <h1>Análisis por Filtros Manuales</h1>

          <button
            type="button"
            className={`info-chip ${showInfo ? 'open' : ''}`}
            onClick={() => setShowInfo(v => !v)}
            aria-label="¿Qué es Análisis Básico?"
            aria-expanded={showInfo}
          >
            <FiInfo size={18} />
          </button>

          <div className={`info-tooltip ${showInfo ? 'show' : ''}`} role="tooltip">
            Este análisis entrega un <strong>perfil general</strong> usando filtros manuales.
            Verás carriers sugeridos según Carrier Software para la combinación elegida.
          </div>
        </div>

        <form onSubmit={handleSubmit}>

            {/* ESTADOS */}
            <div className="form-group">
              <label><strong>Estados (Selección múltiple)*</strong></label>
              <Select
                isMulti
                options={allOptions.map(s => ({ value: s, label: s }))}
                value={statesSelected.map(s => ({ value: s, label: s }))}
                onChange={(selected) => {
                  if (!selected) {
                    setStatesSelected([]);
                    return;
                  }

                  const values = selected.map(opt => opt.value);

                  // Si el usuario selecciona "Todos"
                  if (values.includes(ALL_OPTION)) {
                    // Si NO estaban todos → seleccionar todos
                    if (statesSelected.length !== STATES.length) {
                      setStatesSelected([...STATES]);
                    } else {
                      // Si ya estaban todos → limpiar
                      setStatesSelected([]);
                    }
                    return;
                  }

                  // Si selecciona estados normales
                  setStatesSelected(values);
                }}
                placeholder="Selecciona estados"
              />
            </div>


          {/* SAFETY RATING */}
          <div className="form-group">
            <label><strong>Safety Rating</strong></label>
            <Select
              isMulti
              options={SAFETY_OPTIONS}
              value={SAFETY_OPTIONS.filter(opt => safetySelected.includes(opt.value))}
              onChange={(selected) =>
                setSafetySelected(selected ? selected.map(opt => opt.value) : [])
              }
              placeholder="Selecciona niveles"
            />
          </div>

          {/* YEARS IN BUSINESS */}
          <div className="form-group">
            <label><strong>Years in Business</strong></label>
            <Select
              isMulti
              options={YIB_OPTIONS.map(val => ({ value: val, label: val }))}
              value={yibSelected.map(v => ({ value: v, label: v }))}
              onChange={(selected) =>
                setYibSelected(selected ? selected.map(opt => opt.value) : [])
              }
              placeholder="Selecciona años"
            />
          </div>

          {/* TOTAL POWER UNITS (SE MANTIENE IGUAL) */}
          <div className="form-group">
            <label><strong>Total Power Units</strong></label>
            <Select
              options={OPTIONS_POWER_UNITS}
              isMulti
              value={OPTIONS_POWER_UNITS.filter(opt => powerUnits.includes(opt.value))}
              onChange={(selectedOptions) =>
                setPowerUnits(selectedOptions.map(opt => opt.value))
              }
              placeholder="Selecciona cantidad"
            />
          </div>

          {/* EL RESTO DE TU FORMULARIO QUEDA IGUAL */}


          <div className="form-group">
          <label><strong>Crashes en los últimos 2 años</strong></label>
          <Select
          options={OPTIONS_EVENTS}
          isMulti
          value={OPTIONS_EVENTS.filter(opt => crashes2yr.includes(opt.value))}
          onChange={(selected) => setCrashes2yr(selected.map(opt => opt.value))}
          placeholder="Selecciona cantidad"
          />
          </div>


          <div className="form-group">
          <label><strong>Heridos en los últimos 2 años</strong></label>
          <Select
          options={OPTIONS_EVENTS}
          isMulti
          value={OPTIONS_EVENTS.filter(opt => injuries2yr.includes(opt.value))}
          onChange={(selected) => setInjuries2yr(selected.map(opt => opt.value))}
          placeholder="Selecciona cantidad"
          />
          </div>


          <div className="form-group">
          <label><strong>Muertes en los últimos 2 años</strong></label>
          <Select
          options={OPTIONS_EVENTS}
          isMulti
          value={OPTIONS_EVENTS.filter(opt => fatalities2yr.includes(opt.value))}
          onChange={(selected) => setFatalities2yr(selected.map(opt => opt.value))}
          placeholder="Selecciona cantidad"
          />
          </div>

          <div className="form-group">
            <label><strong>Basic Alerts</strong></label>
            <Select
              options={OPTIONS_EVENTS}
              isMulti
              value={OPTIONS_EVENTS.filter(opt => basicAlerts.includes(opt.value))}
              onChange={(selected) => setBasicAlerts(selected.map(opt => opt.value))}
              placeholder="Selecciona cantidad"
            />
          </div>


          <button type="submit" className="submit-btn" disabled={isLoading}>
            {isLoading ? 'Filtrando…' : 'Aplicar filtros'}
          </button>

            {isLoading && (
              <div className="overlay-loader">
                <Lottie
                  animationData={hourglassAnimation}
                  loop={true}
                  style={{ width: 320, height: 320 }}
                />
                <h2 className="loading-title">
                  Espéranos 1 minutico...
                  <br />
                  <span className="highlight">Estamos buscando tus Carriers 🚛</span>
                </h2>
      
              </div>
            )}
        </form>

        {/* Probabilidades (filtros manuales) */}
        {Array.isArray(apiResponse?.probabilidades) && apiResponse.probabilidades.length > 0 && (
          <TableOrMarkdown
            text={formatCarrierResultadoToTSV(apiResponse.probabilidades)}
            title="De acuerdo con los filtros seleccionados, estos son los Carriers recomendados:"
            className="carrier-probabilities-3d table"
            headerDelimiter="tsv"
            rowDelimiter="tsv"
          />
        )}

        {/* Si el backend devuelve el JSON de “filtros_aplicados” y quieres mostrarlo como referencia: */}
        {/* <pre>{JSON.stringify(apiResponse?.filtros_aplicados, null, 2)}</pre> */}
      </div>
    </div>
  );
};

export default Analisis1;


